var _defs, _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgNavBoard(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 14.4 16",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:#1f1f1f;}"))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M1.2,16a1.159,1.159,0,0,1-.85-.35A1.159,1.159,0,0,1,0,14.8V2.8a1.159,1.159,0,0,1,.35-.85A1.159,1.159,0,0,1,1.2,1.6H5.3A1.775,1.775,0,0,1,5.94.45a1.989,1.989,0,0,1,2.52,0A1.775,1.775,0,0,1,9.1,1.6h4.1a1.2,1.2,0,0,1,1.2,1.2v12A1.2,1.2,0,0,1,13.2,16Zm0-1.2h12V2.8H1.2Zm2-2H8.66V11.6H3.2Zm0-3.4h8V8.2h-8ZM3.2,6h8V4.8h-8Zm4-3.54a.671.671,0,0,0,.49-.21.677.677,0,0,0,0-.98.677.677,0,0,0-.98,0,.677.677,0,0,0,0,.98A.671.671,0,0,0,7.2,2.46ZM1.2,14.8v0Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNavBoard);
export default __webpack_public_path__ + "static/media/nav-board.0269fc41c439c74d209dcfc03c504150.svg";
export { ForwardRef as ReactComponent };